import * as React from 'react';
/**
 * Directory base
 */
export class ComplexBase extends React.PureComponent {
    render() {
        return null;
    }
}
ComplexBase.isDirective = true;
